import fetchHandler from "../../utils/fetchHandler";
import { FOOD_DATABASE } from "../types/actions";

export const getFoodDatabase = (queryString) => {
	const fetchOptions = {
		url: `/api/hier1?${queryString}`,
		method: "GET",
		actionType: FOOD_DATABASE.GET_FOOD_DATABASE,
	};
	return fetchHandler(fetchOptions);
};

export const getFoodDatabaseLevelTwo = (queryString) => {
	const fetchOptions = {
		url: `/api/hier2?${queryString}`,
		method: "GET",
		actionType: FOOD_DATABASE.GET_FOOD_DATABASE_LEVEL_2,
	};
	return fetchHandler(fetchOptions);
};

export const getFoodDatabaseLevelThree = (queryString) => {
	const fetchOptions = {
		url: `/api/hier3?${queryString}`,
		method: "GET",
		actionType: FOOD_DATABASE.GET_FOOD_DATABASE_LEVEL_3,
	};
	return fetchHandler(fetchOptions);
};

export const getFoodListCardView = (queryString) => {
	const fetchOptions = {
		url: `/api/food?${queryString}`,
		method: "GET",
		actionType: FOOD_DATABASE.GET_FOOD_LIST_CARD_VIEW,
	};
	return fetchHandler(fetchOptions);
};

export const getFoodDatabaseLevelFour = (queryString) => {
	const fetchOptions = {
		url: `/api/food?${queryString}`,
		method: "GET",
		actionType: FOOD_DATABASE.GET_FOOD_DATABASE_LEVEL_4,
	};
	return fetchHandler(fetchOptions);
};

export const getFoodDetails = (queryString) => {
	const fetchOptions = {
		url: `/api/food/${queryString}/`,
		method: "GET",
		actionType: FOOD_DATABASE.GET_FOOD_DETAILS,
	};
	return fetchHandler(fetchOptions);
};

export const searchFoodNutrition = (queryString, successHandler) => {
	const fetchOptions = {
		url: `/api/food/${queryString}`,
		method: "GET",
		actionType: FOOD_DATABASE.GET_FOOD_NUTRITION,
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const getNutData = (queryString) => {
	const fetchOptions = {
		url: `/api/nut?food=${queryString}`,
		method: "GET",
		actionType: FOOD_DATABASE.GET_NUT_DATA,
	};
	return fetchHandler(fetchOptions);
};

export const updateNutData = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/nut/bulk_update/?food=${values.id}`,
		method: "PUT",
		actionType: FOOD_DATABASE.UPDATE_NUT_DATA,
		body: JSON.stringify(values.data),
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const getIngredientWeights = (id) => {
	const fetchOptions = {
		url: `/api/ingredient_weights/?food=${id}`,
		method: "GET",
		actionType: FOOD_DATABASE.GET_INGREDIENT_WEIGHTS,
	};
	return fetchHandler(fetchOptions);
};

export const addIngredientWeights = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/ingredients_weights/bulk_create/?food=${values.id}`,
		method: "POST",
		actionType: FOOD_DATABASE.ADD_INGREDIENT_WEIGHTS,
		body: JSON.stringify(values.data),
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const updateIngredientWeights = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/ingredient_weights/${values.id}/`,
		method: "PUT",
		actionType: FOOD_DATABASE.UPDATE_INGREDIENT_WEIGHTS,
		body: JSON.stringify(values),
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const deleteIngredientWeights = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/ingredient_weights/${values.id}/`,
		method: "DELETE",
		actionType: FOOD_DATABASE.DELETE_INGREDIENT_WEIGHTS,
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const saveFoodItem = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/food/${values.id}`,
		method: "PUT",
		actionType: FOOD_DATABASE.SAVE_FOOD_DETAILS,
		body: JSON.stringify(values),
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const addFoodItem = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/food/`,
		method: "POST",
		actionType: FOOD_DATABASE.ADD_FOOD_ITEM,
		body: JSON.stringify(values),
	};

	return fetchHandler(fetchOptions, successHandler);
};

// Added patient food list action
export const getFoodApprovalList = (queryString) => {
	const fetchOptions = {
		url: `/api/food/approve_food?${queryString}`,
		method: "GET",
		actionType: FOOD_DATABASE.GET_FOOD_APPROVAL_LIST,
	};
	return fetchHandler(fetchOptions);
};

export const approveFoodItem = (id, successHandler) => {
	const fetchOptions = {
		url: `/api/food/approve_food`,
		method: "POST",
		actionType: FOOD_DATABASE.APPROVE_FOOD_ITEM,
		body: JSON.stringify({ approved_food_id: id }),
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const searchPatientFood = (queryString, successHandler) => {
	const fetchOptions = {
		url: `/api/food/approve_food?search=${queryString}`,
		method: "GET",
		actionType: FOOD_DATABASE.SEARCH_PATIENT_FOOD,
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const getPatientFoodDetails = (queryString) => {
	const fetchOptions = {
		url: `/api/food/${queryString}/`,
		method: "GET",
		actionType: FOOD_DATABASE.GET_PATIENT_FOOD_DETAILS,
	};
	return fetchHandler(fetchOptions);
};

export const declineFood = (values, successHandler, errorHandler) => {
	const fetchOptions = {
		url: `/api/food/${values.id}/decline/?decline_code=${values.decline_code}`,
		method: "POST",
		actionType: FOOD_DATABASE.DECLINE_FOOD,
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
};
